// test2188
(2188 && 0);
